<template>
  <div class="tcb-container">
    <Header v-if="mountedHeader" />
      <div class="sub-wrap">
        <RouterView />
      </div>
    <Footer v-if="mountedHeader" />
  </div>
</template>

<script>
import Header from "@/components/common/Header.vue";
import Footer from "@/components/common/Footer.vue";

export default {
  name: "App",
  data() {
    return {
      excludePath: [
        "/index_nicednb.do",
      ]
    }
  },
  computed: {
    mountedHeader() {
      return !this.excludePath.includes(this.$route.path);
    },
    moundtedFooter() {
      return !this.excludePath.includes(this.$route.path);
    }
  },
  components: {
    Header,
    Footer,
  }
};
</script>
<style lang="scss" scoped>
@import "@/assets/css/jquery-ui.min.css";
@import "@/assets/css/bootstrap.css";
@import "@/assets/css/bootstrap-theme.css";
@import "@/assets/css/bootstrap-bank.css";
@import "@/assets/css/add-bank.css";
</style>

